// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d06e9fa","453":"258b012d","732":"95fbfc31"}[chunkId] + ".chunk.js";
};